// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home[data-v-2677a6f8] {\n  height: calc(100vh - 166px);\n}\n", ""]);
// Exports
module.exports = exports;
